import React, { useState } from 'react';
import styles from '../styles/Support.module.css';

const FAQ = () => {
  const [expandedItems, setExpandedItems] = useState(new Set());

  const faqData = [
    {
      id: 1,
      question: "How long does shipping take?",
      answer: "Standard shipping typically takes 3-5 business days within India. Express shipping is available for 1-2 business days delivery. International shipping may take 7-14 business days depending on the destination."
    },
    {
      id: 2,
      question: "What is your return policy?",
      answer: "We offer a 30-day return policy for all unused items in their original packaging. If you're not satisfied with your purchase, you can return it for a full refund or exchange. Return shipping costs are the responsibility of the customer unless the item was received damaged or incorrect."
    },
    {
      id: 3,
      question: "Are your candles safe to use?",
      answer: "Yes, all our candles are made with premium, non-toxic materials and meet international safety standards. They are lead-free and use natural wax. Always follow the safety instructions provided with each candle and never leave a burning candle unattended."
    },
    {
      id: 4,
      question: "Do you offer wholesale pricing?",
      answer: "Yes, we offer wholesale pricing for bulk orders. Please contact our sales team at wholesale@klcreation.com with your requirements and we'll provide you with a custom quote."
    },
    {
      id: 5,
      question: "How can I track my order?",
      answer: "Once your order ships, you'll receive a tracking number via email. You can also track your order by logging into your account and visiting the 'My Orders' section."
    },
    {
      id: 6,
      question: "What payment methods do you accept?",
      answer: "We accept all major credit cards (Visa, MasterCard, American Express), debit cards, UPI, net banking, and digital wallets like Paytm, PhonePe, and Google Pay. All payments are processed securely through our payment gateway."
    },
    {
      id: 7,
      question: "Can I customize candles for special occasions?",
      answer: "Yes, we offer custom candle making services for special occasions like weddings, corporate events, and personal gifts. Please contact us at least 2 weeks in advance for custom orders."
    },
    {
      id: 8,
      question: "How should I store my candles?",
      answer: "Store your candles in a cool, dry place away from direct sunlight and heat sources. Keep them in their original packaging when not in use to preserve their fragrance and prevent dust accumulation."
    },
    {
      id: 9,
      question: "Do you ship internationally?",
      answer: "Yes, we ship to most countries worldwide. International shipping rates and delivery times vary by location. You can check shipping costs during checkout by entering your address."
    },
    {
      id: 10,
      question: "What if my candle arrives damaged?",
      answer: "If your candle arrives damaged, please take photos of the damage and contact us within 48 hours of delivery. We'll arrange for a replacement or refund at no additional cost to you."
    }
  ];

  const toggleItem = (id) => {
    const newExpanded = new Set(expandedItems);
    if (newExpanded.has(id)) {
      newExpanded.delete(id);
    } else {
      newExpanded.add(id);
    }
    setExpandedItems(newExpanded);
  };

  return (
    <div className={styles.supportContainer}>
      <div className={styles.headerRow}>
        <h2>Frequently Asked Questions</h2>
      </div>
      
      <div style={{ marginTop: '2rem' }}>
        {faqData.map((item) => (
          <div
            key={item.id}
            style={{
              background: '#f8fafc',
              marginBottom: '1rem',
              borderRadius: '12px',
              overflow: 'hidden',
              border: '1px solid #e5e7eb'
            }}
          >
            <button
              onClick={() => toggleItem(item.id)}
              style={{
                width: '100%',
                background: 'transparent',
                border: 'none',
                padding: '1.5rem',
                textAlign: 'left',
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                fontSize: '1.1rem',
                fontWeight: '600',
                color: '#232323',
                transition: 'background-color 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#f1f5f9'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
            >
              <span>{item.question}</span>
              <span style={{
                fontSize: '1.5rem',
                transition: 'transform 0.2s',
                transform: expandedItems.has(item.id) ? 'rotate(180deg)' : 'rotate(0deg)'
              }}>
                ▼
              </span>
            </button>
            
            {expandedItems.has(item.id) && (
              <div style={{
                padding: '0 1.5rem 1.5rem 1.5rem',
                color: '#666',
                lineHeight: '1.6',
                borderTop: '1px solid #e5e7eb',
                background: '#fff'
              }}>
                {item.answer}
              </div>
            )}
          </div>
        ))}
      </div>
      
      <div style={{
        marginTop: '3rem',
        padding: '2rem',
        background: '#e0e7ff',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <h3 style={{ color: '#3730a3', marginBottom: '1rem' }}>Still have questions?</h3>
        <p style={{ color: '#6366f1', marginBottom: '1.5rem' }}>
          Can't find the answer you're looking for? Our support team is here to help!
        </p>
        <button
          onClick={() => window.location.href = '/admin/support/contact'}
          style={{
            background: '#6366f1',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            padding: '0.75rem 1.5rem',
            fontSize: '1rem',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'background 0.2s'
          }}
        >
          Contact Support
        </button>
      </div>
    </div>
  );
};

export default FAQ; 